function getAudienceSize(audience) {
  let max_size = 0
  for (let key in audience.sizes) {
    if (audience.sizes[key] > max_size) {
      max_size = audience.sizes[key]
    }
  }
  if (audience.sizes && audience.sizes.global) {
    return audience.sizes.global
  } else if (audience.sizes && audience.sizes.us) {
    return audience.sizes.us
  } else if (max_size > 0) {
    return max_size
  }
  return audience.est_size
}

export default getAudienceSize
